import { createContext } from 'react';
import { ExpressionContext } from '../../../../../../../@Component/Domain/Expression/ExpressionContext';

export default createContext<ExpressionContext>(undefined);
